// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__DzBM1","footer":"ModalInfo_footer__Hq-TH"};